export interface MangaItem {
  id: string;
  title: string;
  author: string;
  genre: string;
  tags: string[];
  rating: string;
  status: string;
  cover: string;
  desc: string;
  reason: string;
}

export interface Category {
  id: string;
  name: string;
  count: string;
  icon: string;
  image: string;
  desc: string;
}

export interface RankItem {
  id: string;
  rank: number;
  title: string;
  genre: string;
  score: string;
  cover: string;
}

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  avatar: string;
  text: string;
}

export interface Faq {
  id: string;
  q: string;
  a: string;
}

export const featuredManga: MangaItem[] = [
  {
    id: "burning-road",
    title: "燃骨之路",
    author: "青井遥",
    genre: "热血冒险",
    tags: ["战斗", "成长", "燃向"],
    rating: "9.6",
    status: "连载中 · 128话",
    cover: "https://readdy.ai/api/search-image?query=stylish%20manga%20comic%20book%20cover%20of%20a%20young%20hero%20with%20fiery%20energy%20and%20crimson%20aura%2C%20dynamic%20action%20pose%2C%20bold%20bold%20ink%20lines%2C%20vibrant%20red%20and%20amber%20palette%2C%20clean%20warm%20cream%20background%2C%20high%20contrast%20illustration%2C%20portrait%20composition&width=600&height=800&seq=cover-burn&orientation=portrait",
    desc: "少年从废土走向巅峰的热血冒险。一场关于信念、伙伴与『燃烧』的战斗史诗，每一话都让人血脉偾张。",
    reason: "画风张力十足，剧情从不拖沓，燃点密集到全程无尿点，是本命榜单的常驻传说。",
  },
  {
    id: "sakura-letter",
    title: "樱色信笺",
    author: "藤井澄",
    genre: "恋爱青春",
    tags: ["校园", "纯爱", "成长"],
    rating: "9.5",
    status: "已完结 · 96话",
    cover: "https://readdy.ai/api/search-image?query=soft%20romantic%20manga%20comic%20cover%20of%20two%20school%20students%20under%20cherry%20blossoms%2C%20gentle%20pastel%20pink%20and%20warm%20amber%20tone%2C%20clean%20minimal%20illustration%2C%20youthful%20and%20heartwarming%2C%20warm%20cream%20background%2C%20portrait%20composition&width=600&height=800&seq=cover-sakura&orientation=portrait",
    desc: "一封迟到的信，牵起两个人跨越整个青春的温柔告白。细腻到骨子里的纯爱故事，适合慢慢回味。",
    reason: "情感的细腻程度堪称教科书级，看完只想为它封神，是『一生推』恋爱漫的绝佳入坑。",
  },
  {
    id: "mist-alchemy",
    title: "雾都炼金术",
    author: "白濑朔",
    genre: "奇幻冒险",
    tags: ["世界观", "魔法", "悬疑"],
    rating: "9.4",
    status: "连载中 · 152话",
    cover: "https://readdy.ai/api/search-image?query=dark%20fantasy%20manga%20comic%20cover%20with%20an%20alchemist%20and%20glowing%20mystic%20rune%2C%20moody%20foggy%20city%20backdrop%2C%20deep%20teal%20and%20amber%20glow%2C%20intricate%20detail%2C%20stylized%20illustration%2C%20high%20contrast%2C%20portrait%20composition&width=600&height=800&seq=cover-mist&orientation=portrait",
    desc: "在永远笼罩浓雾的都城里，年轻的炼金术师追寻被掩盖的真相。宏大世界观 + 烧脑设定，越看越上头。",
    reason: "设定严谨又迷人，每一格都在埋线，追更的每一天都是快乐，奇幻入坑的首选之一。",
  },
  {
    id: "seventh-gate",
    title: "第七重门",
    author: "黑泽凛",
    genre: "悬疑烧脑",
    tags: ["推理", "反转", "心理"],
    rating: "9.5",
    status: "已完结 · 88话",
    cover: "https://readdy.ai/api/search-image?query=tense%20suspense%20manga%20comic%20cover%20of%20a%20detective%20facing%20seven%20glowing%20doors%2C%20dark%20moody%20atmosphere%2C%20crimson%20and%20amber%20accent%20lighting%2C%20clever%20composition%2C%20stylized%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=cover-gate&orientation=portrait",
    desc: "七扇门背后藏着七个真相。每一步推理都环环相扣，结局的反转让人直呼『原来如此』。",
    reason: "逻辑严丝合缝，几乎没有废笔，读完只想立刻重刷，悬疑漫入坑的高光之作。",
  },
  {
    id: "mountain-bakery",
    title: "山野面包店",
    author: "早乙女森",
    genre: "治愈日常",
    tags: ["治愈", "美食", "慢生活"],
    rating: "9.3",
    status: "连载中 · 74话",
    cover: "https://readdy.ai/api/search-image?query=cozy%20healing%20manga%20comic%20cover%20of%20a%20rustic%20bakery%20with%20fresh%20bread%20and%20a%20warm%20smiling%20shopkeeper%2C%20soft%20warm%20amber%20and%20cream%20tone%2C%20gentle%20wholesome%20illustration%2C%20portrait%20composition&width=600&height=800&seq=cover-bakery&orientation=portrait",
    desc: "开在深山里的面包店，用温度治愈每一个路过的疲惫灵魂。看完想立刻去乡下发呆一整年。",
    reason: "治愈系天花板，画风温柔得像在晒太阳，忙碌一天后最想翻开的『本命』。",
  },
  {
    id: "star-tide",
    title: "星潮纪元",
    author: "御堂亮",
    genre: "科幻太空",
    tags: ["太空", "机甲", "群像"],
    rating: "9.4",
    status: "连载中 · 136话",
    cover: "https://readdy.ai/api/search-image?query=epic%20sci%20fi%20manga%20comic%20cover%20of%20a%20mecha%20pilot%20in%20deep%20space%20with%20nebulae%20and%20stars%2C%20teal%20and%20amber%20glowing%20accents%2C%20dramatic%20composition%2C%20stylized%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=cover-star&orientation=portrait",
    desc: "人类驶向深空的第一百年，一群少年在星海间书写自己的答案。宏大群像与细腻情感并存。",
    reason: "世界观磅礴却讲得极清楚，机甲热血与人情冷暖平衡得恰到好处，科幻入坑不二之选。",
  },
];

export const categories: Category[] = [
  {
    id: "action",
    name: "热血战斗",
    count: "186部本命",
    icon: "ri-flashlight-fill",
    image: "https://readdy.ai/api/search-image?query=dynamic%20action%20manga%20illustration%20with%20energy%20blast%20and%20fighting%20silhouette%2C%20bold%20crimson%20and%20amber%20palette%2C%20clean%20cream%20background%2C%20stylized%20comic%20art&width=640&height=480&seq=cat-action&orientation=landscape",
    desc: "燃到发烫的战斗漫画，打斗分镜拳拳到肉",
  },
  {
    id: "romance",
    name: "恋爱青春",
    count: "142部本命",
    icon: "ri-heart-3-fill",
    image: "https://readdy.ai/api/search-image?query=gentle%20romance%20manga%20illustration%20with%20cherry%20blossoms%20and%20couple%20silhouette%2C%20soft%20pink%20and%20warm%20amber%20tone%2C%20clean%20cream%20background%2C%20stylized%20comic%20art&width=640&height=480&seq=cat-romance&orientation=landscape",
    desc: "细腻纯爱与青涩心动，恋爱的每一个瞬间",
  },
  {
    id: "fantasy",
    name: "奇幻冒险",
    count: "118部本命",
    icon: "ri-sparkling-2-fill",
    image: "https://readdy.ai/api/search-image?query=fantasy%20adventure%20manga%20illustration%20with%20magic%20rune%20and%20fantasy%20creature%2C%20teal%20and%20amber%20glow%2C%20stylized%20comic%20art%2C%20clean%20warm%20background&width=640&height=480&seq=cat-fantasy&orientation=landscape",
    desc: "宏大世界观与奇妙旅程，想象力没有边界",
  },
  {
    id: "mystery",
    name: "悬疑烧脑",
    count: "96部本命",
    icon: "ri-key-2-fill",
    image: "https://readdy.ai/api/search-image?query=mystery%20suspense%20manga%20illustration%20with%20magnifying%20glass%20and%20question%20marks%20silhouette%2C%20crimson%20and%20dark%20amber%20tone%2C%20stylized%20comic%20art%2C%20clean%20background&width=640&height=480&seq=cat-mystery&orientation=landscape",
    desc: "环环相扣的推理与反转，不到最后猜不到结局",
  },
  {
    id: "healing",
    name: "治愈日常",
    count: "104部本命",
    icon: "ri-cup-fill",
    image: "https://readdy.ai/api/search-image?query=cozy%20healing%20manga%20illustration%20with%20warm%20tea%20cup%20and%20sunset%20window%2C%20soft%20warm%20amber%20and%20cream%20tone%2C%20gentle%20stylized%20comic%20art%2C%20clean%20background&width=640&height=480&seq=cat-healing&orientation=landscape",
    desc: "温柔到心坎的日常故事，给生活充一点电",
  },
  {
    id: "comedy",
    name: "搞笑日常",
    count: "88部本命",
    icon: "ri-emotion-laugh-fill",
    image: "https://readdy.ai/api/search-image?query=playful%20comedy%20manga%20illustration%20with%20funny%20chibi%20characters%20and%20confetti%2C%20bright%20amber%20and%20red%20palette%2C%20stylized%20comic%20art%2C%20clean%20warm%20background&width=640&height=480&seq=cat-comedy&orientation=landscape",
    desc: "笑到停不下来的搞笑日常，减压第一选择",
  },
];

export const rankings: RankItem[] = [
  { id: "r1", rank: 1, title: "燃骨之路", genre: "热血冒险", score: "9.6", cover: "https://readdy.ai/api/search-image?query=fiery%20action%20manga%20cover%20with%20hero%20and%20crimson%20energy%2C%20bold%20comic%20art%2C%20clean%20warm%20cream%20background%2C%20portrait&width=360&height=480&seq=rank-01&orientation=portrait" },
  { id: "r2", rank: 2, title: "樱色信笺", genre: "恋爱青春", score: "9.5", cover: "https://readdy.ai/api/search-image?query=romantic%20manga%20cover%20with%20cherry%20blossom%20and%20couple%2C%20soft%20pink%20warm%20tone%2C%20stylized%20comic%20art%2C%20clean%20cream%20background%2C%20portrait&width=360&height=480&seq=rank-02&orientation=portrait" },
  { id: "r3", rank: 3, title: "第七重门", genre: "悬疑烧脑", score: "9.5", cover: "https://readdy.ai/api/search-image?query=mystery%20manga%20cover%20with%20doors%20and%20shadowy%20figure%2C%20dark%20red%20accent%2C%20stylized%20comic%20art%2C%20clean%20cream%20background%2C%20portrait&width=360&height=480&seq=rank-03&orientation=portrait" },
  { id: "r4", rank: 4, title: "雾都炼金术", genre: "奇幻冒险", score: "9.4", cover: "https://readdy.ai/api/search-image?query=fantasy%20manga%20cover%20with%20alchemist%20and%20glowing%20rune%2C%20teal%20amber%20glow%2C%20stylized%20comic%20art%2C%20clean%20cream%20background%2C%20portrait&width=360&height=480&seq=rank-04&orientation=portrait" },
  { id: "r5", rank: 5, title: "星潮纪元", genre: "科幻太空", score: "9.4", cover: "https://readdy.ai/api/search-image?query=sci%20fi%20manga%20cover%20with%20mecha%20and%20nebula%20space%2C%20teal%20amber%20accents%2C%20stylized%20comic%20art%2C%20clean%20cream%20background%2C%20portrait&width=360&height=480&seq=rank-05&orientation=portrait" },
  { id: "r6", rank: 6, title: "山野面包店", genre: "治愈日常", score: "9.3", cover: "https://readdy.ai/api/search-image?query=healing%20manga%20cover%20with%20cozy%20bakery%20and%20bread%2C%20soft%20warm%20amber%2C%20stylized%20comic%20art%2C%20clean%20cream%20background%2C%20portrait&width=360&height=480&seq=rank-06&orientation=portrait" },
  { id: "r7", rank: 7, title: "社畜大作战", genre: "搞笑日常", score: "9.2", cover: "https://readdy.ai/api/search-image?query=comedy%20manga%20cover%20with%20frazzled%20office%20worker%20and%20fun%20chibi%2C%20bright%20red%20amber%2C%20stylized%20comic%20art%2C%20clean%20cream%20background%2C%20portrait&width=360&height=480&seq=rank-07&orientation=portrait" },
  { id: "r8", rank: 8, title: "深海回响", genre: "悬疑惊悚", score: "9.1", cover: "https://readdy.ai/api/search-image?query=underwater%20thriller%20manga%20cover%20with%20abyss%20and%20echo%20waves%2C%20teal%20dark%20accent%2C%20stylized%20comic%20art%2C%20clean%20cream%20background%2C%20portrait&width=360&height=480&seq=rank-08&orientation=portrait" },
];

export const testimonials: Testimonial[] = [
  {
    id: "t1",
    name: "林一航",
    role: "追漫9年 · 热血党",
    avatar: "https://readdy.ai/api/search-image?query=flat%20minimal%20avatar%20illustration%20of%20a%20young%20male%20anime%20fan%2C%20warm%20cream%20background%2C%20simple%20stylized%20portrait&width=120&height=120&seq=avatar-01&orientation=squarish",
    text: "之前入坑踩雷无数，自从跟着131的本命推荐挑，基本没翻过车。燃骨之路就是照着榜单追的，现在是我的本命没跑了。",
  },
  {
    id: "t2",
    name: "苏小满",
    role: "纯爱战士",
    avatar: "https://readdy.ai/api/search-image?query=flat%20minimal%20avatar%20illustration%20of%20a%20young%20female%20anime%20fan%2C%20warm%20cream%20background%2C%20simple%20stylized%20portrait&width=120&height=120&seq=avatar-02&orientation=squarish",
    text: "樱色信笺真的杀我，画风软到心都化了。131的推荐文案也很懂，每次都能精准戳中我想要的类型。",
  },
  {
    id: "t3",
    name: "陈屿",
    role: "悬疑推理控",
    avatar: "https://readdy.ai/api/search-image?query=flat%20minimal%20avatar%20illustration%20of%20a%20young%20male%20with%20glasses%2C%20warm%20cream%20background%2C%20simple%20stylized%20portrait&width=120&height=120&seq=avatar-03&orientation=squarish",
    text: "找烧脑本命好难，踩雷踩到怀疑人生。第七重门是131推的，从头到尾没让我失望，反转直接封神。",
  },
  {
    id: "t4",
    name: "周子墨",
    role: "工作党 · 治愈系",
    avatar: "https://readdy.ai/api/search-image?query=flat%20minimal%20avatar%20illustration%20of%20a%20young%20female%20with%20long%20hair%2C%20warm%20cream%20background%2C%20simple%20stylized%20portrait&width=120&height=120&seq=avatar-04&orientation=squarish",
    text: "加班到崩溃，就想看点治愈的。山野面包店是131推荐给我的，看完真的被治愈了，现在每天睡前必翻。",
  },
];

export const faqs: Faq[] = [
  {
    id: "f1",
    q: "131漫画网的『本命推荐』是怎么挑选入坑作的？",
    a: "我们按照『本命』的标准来筛选：优先选择画风稳定、剧情连贯、人物立体且情感浓度高的作品。每一部入选的漫画都经过多个维度的反复比对，确保从画风到剧情都具备『能当本命』的潜力，尽量减少踩雷概率。",
  },
  {
    id: "f2",
    q: "什么是『一生推』的入坑作？",
    a: "『一生推』是指那种看一遍会忍不住反复重温、愿意安利给所有朋友、并会一直追下去的作品。这类入坑作往往综合质量极高，无论你之前是什么口味，都有极大可能在其中找到属于自己的本命。",
  },
  {
    id: "f3",
    q: "我不确定自己喜欢什么类型，该怎么挑选？",
    a: "建议从『入坑指南』板块入手，先按自己的喜好初步锁定1-2个类型，再结合热门排行和分类推荐挑选口碑与评分靠前的作品。也可以直接浏览首页的本命推荐精选，这些都是跨类型的高质量代表。",
  },
  {
    id: "f4",
    q: "榜单上的评分和口碑可靠吗？",
    a: "评分综合了作品本身的质量、读者的长期口碑以及编辑团队的反复测评，会随着更新动态调整。我们鼓励每一位读者在看完后留下自己的评价，让口碑越来越贴近真实体验。",
  },
  {
    id: "f5",
    q: "推荐的作品会不会突然断更或烂尾？",
    a: "我们只推荐创作状态稳定、口碑持续向好的作品。对于已完结的入坑作，会明确标注『已完结』；对于连载中的作品，也会标注更新进度，方便你根据自己的追更习惯做选择。",
  },
  {
    id: "f6",
    q: "想推荐一部很棒的本命漫给131漫画网，可以吗？",
    a: "当然可以！我们非常欢迎读者安利自己心中的本命。你可以通过页面底部的联系方式把你的推荐作品和理由告诉我们，审核通过后就有机会登上本命推荐列表，让更多同好发现它。",
  },
];

export const guideSteps = [
  {
    id: "g1",
    icon: "ri-eye-line",
    title: "先看画风",
    desc: "画风是第一印象，也是决定你能不能长期追下去的关键。先看你喜欢的线条和上色风格，再谈剧情。",
  },
  {
    id: "g2",
    icon: "ri-message-3-line",
    title: "再读剧情",
    desc: "剧情是留住本命的根本。看它是否环环相扣、人物是否立体、节奏是否让你欲罢不能。",
  },
  {
    id: "g3",
    icon: "ri-heart-3-line",
    title: "感受共鸣",
    desc: "真正能成为本命的作品，一定会在某个瞬间击中你的内心。那种『就是它了』的感觉，就是本命。",
  },
  {
    id: "g4",
    icon: "ri-flag-2-line",
    title: "放心入坑",
    desc: "选好之后放心去追。入坑不是终点，而是开启一段与本命漫的长久陪伴。一生推，从此开始。",
  },
];